import { useMutation } from '@tanstack/react-query';

import { updateEstimateStatus } from '@widgets/EstimateInformation/api/updateEstimateStatus';

export const useUpdateEstimateStatusQuery = () =>
    useMutation({
        mutationKey: ['updateEstimateStatus'],
        mutationFn: updateEstimateStatus,
    });
